var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"macroapp--page-common macroapp"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loaded)?_c('page-content-skeleton'):_vm._e(),(_vm.loaded)?_c(_vm.dynamicComponent,{tag:"component"}):_vm._e()],1),(_vm.notFoundPage)?_c('popup-not-found-error',{on:{"close":function($event){return _vm.goBack()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }